import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const articleImages: Record<string, string> = {
  'xinshou-ru-men-gonglue': 'https://readdy.ai/api/search-image?query=Anime%20style%20fantasy%20adventure%20scene%20with%20cute%20characters%20in%20magical%20island%2C%20soft%20pastel%20colors%2C%20dreamy%20lighting%2C%20cherry%20blossom%20petals%2C%20warm%20and%20inviting%20tone&width=800&height=450&seq=article-xinshou&orientation=landscape',
  'shenmi-daoju-zhong-sheng-zhi-mi': 'https://readdy.ai/api/search-image?query=Anime%20style%20mystical%20rebirth%20ceremony%20scene%20with%20glowing%20crystals%20and%20magic%20circle%2C%20soft%20pink%20and%20mint%20tones%2C%20ethereal%20atmosphere%2C%20sparkling%20particles&width=800&height=450&seq=article-zhongsheng&orientation=landscape',
  'renqi-juese-xiaoying-xiangjie': 'https://readdy.ai/api/search-image?query=Anime%20style%20cute%20healer%20girl%20character%20with%20pink%20hair%20and%20cherry%20blossom%20petals%2C%20gentle%20smile%2C%20magical%20healing%20aura%2C%20soft%20pastel%20background&width=800&height=450&seq=article-xiaoying&orientation=landscape',
  'xinghu-yiji-tanxian-riji': 'https://readdy.ai/api/search-image?query=Anime%20style%20ancient%20ruins%20with%20starry%20lake%20reflection%2C%20mysterious%20glowing%20crystals%2C%20adventure%20party%20exploring%2C%20fantasy%20atmosphere%2C%20soft%20lighting&width=800&height=450&seq=article-xinghu&orientation=landscape',
  'gaojie-zhandou-jiqiao': 'https://readdy.ai/api/search-image?query=Anime%20style%20epic%20battle%20scene%20with%20cute%20characters%20fighting%20monsters%2C%20magical%20effects%2C%20dynamic%20action%20pose%2C%20soft%20pastel%20colors&width=800&height=450&seq=article-zhandou&orientation=landscape',
  'qihuan-shijie-sheding-quanjie': 'https://readdy.ai/api/search-image?query=Anime%20style%20fantasy%20world%20map%20of%20magical%20floating%20islands%2C%20seven%20elemental%20crystals%2C%20ancient%20scrolls%2C%20mystical%20constellations%2C%20soft%20pastel%20palette&width=800&height=450&seq=article-shijieguan&orientation=landscape',
};

export default function FeaturedArticles() {
  const featured = articles.slice(0, 6);

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-12">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-900 mb-4">
              精选文章
            </h2>
            <p className="text-foreground-600">最新最热的重生萝莉岛内容推荐</p>
          </div>
          <Link
            to="/category/gonglue"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {featured.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group block bg-background-50 rounded-xl overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={articleImages[article.slug] || articleImages['xinshou-ru-men-gonglue']}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 bg-primary-500 text-white text-xs rounded-full font-medium">
                    {article.categoryName}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-semibold text-foreground-900 text-base mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 line-clamp-2 mb-4 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span>{article.date}</span>
                  <span>{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/gonglue"
            className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}